// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DT96","type":"styles_type__3p3lo","choices":"styles_choices__1GqVB"};